import OrderDetails from './OrderDetails/OrderDetails'

const frameworkComponents = {
  detailOrderDetails: OrderDetails
}

export default frameworkComponents
